import { render, staticRenderFns } from "./ReceiptPanel.vue?vue&type=template&id=63325b2a&scoped=true"
import script from "./ReceiptPanel.vue?vue&type=script&lang=js"
export * from "./ReceiptPanel.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPanel.vue?vue&type=style&index=0&id=63325b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63325b2a",
  null
  
)

export default component.exports